if (!customElements.get("custom-donation-price")) {
	const MINIMUM_FREE_FORM_DONATION_EUR = 10;

	customElements.define(
		"custom-donation-price",
		class CustomDonationPrice extends HTMLElement {
			constructor() {
				super();
				this.input = this.querySelector("[data-custom-donation-input]");
				this.hint = this.querySelector("[data-custom-donation-hint]");
				this.errorEl = this.querySelector("[data-custom-donation-error]");
				const configuredValues =
					this.dataset.freeFormOptionValues ||
					this.dataset.freeFormOptionValue ||
					"Scegli";
				this.freeFormOptionValues = configuredValues
					.split("|")
					.map((value) => value.trim())
					.filter(Boolean);
				this.propertyName = this.dataset.propertyName || "_custom_price";
				this.showBuyButtonPrice = this.dataset.showBuyButtonPrice === "true";
				this.currentVariant = null;
				this.onSubmitHandler = this.onSubmitHandler.bind(this);
			}

			connectedCallback() {
				this.form = document.getElementById(this.dataset.formId);

				this.variantChangeUnsubscriber = theme.pubsub.subscribe(
					theme.pubsub.PUB_SUB_EVENTS.variantChange,
					(event) => {
						if (event.data.sectionId === this.dataset.sectionId) {
							this.onVariantChanged(event.data.variant);
						}
					},
				);

				this.form?.addEventListener("submit", this.onSubmitHandler, true);

				const initialVariant = this.getInitialVariant();
				if (initialVariant) {
					this.onVariantChanged(initialVariant);
				}
			}

			disconnectedCallback() {
				this.variantChangeUnsubscriber?.();
				this.form?.removeEventListener("submit", this.onSubmitHandler, true);
			}

			getInitialVariant() {
				const picker = document.getElementById(
					`VariantPicker-${this.dataset.sectionId}-${this.dataset.productId}`,
				);
				const json = picker?.querySelector(
					"[data-selected-variant]",
				)?.textContent;
				if (!json) return null;

				try {
					return JSON.parse(json);
				} catch {
					return null;
				}
			}

			isFreeFormVariant(variant) {
				return this.freeFormOptionValues.includes(variant?.option1);
			}

			updateBuyButtonPriceVisibility(isFreeForm) {
				if (!this.showBuyButtonPrice) return;

				const buyButtonPrice = document.getElementById(
					`BuyButtonPrice-${this.dataset.sectionId}-${this.dataset.productId}`,
				);
				const submitButton = this.form?.querySelector(".product-form__submit");

				if (!buyButtonPrice) return;

				buyButtonPrice.toggleAttribute("hidden", isFreeForm);
				submitButton?.classList.toggle("with-price", !isFreeForm);
			}

			updateMainPriceVisibility(isFreeForm) {
				const mainPrices = document.querySelectorAll(
					"[data-donation-main-price]",
				);

				mainPrices.forEach((mainPrice) => {
					mainPrice.classList.toggle(
						"is-donation-price-reserved-hidden",
						isFreeForm,
					);

					if (isFreeForm) {
						mainPrice.setAttribute("aria-hidden", "true");
					} else {
						mainPrice.removeAttribute("aria-hidden");
					}
				});
			}

			onVariantChanged(variant) {
				this.currentVariant = variant;
				const isFreeForm = this.isFreeFormVariant(variant);

				this.classList.toggle("hidden", !isFreeForm);
				this.updateBuyButtonPriceVisibility(isFreeForm);
				this.updateMainPriceVisibility(isFreeForm);
				if (!this.input) return;

				if (isFreeForm) {
					const maxAmount = (variant.price / 100).toFixed(2);

					this.input.setAttribute("name", `properties[${this.propertyName}]`);
					this.input.required = true;
					this.input.disabled = false;
					this.input.setAttribute("min", "10.00");
					this.input.max = maxAmount;

					const currentValue = parseFloat(this.input.value);
					if (
						!Number.isNaN(currentValue) &&
						currentValue < MINIMUM_FREE_FORM_DONATION_EUR
					) {
						this.input.value = "";
						this.clearError();
					}

					if (this.hint) {
						this.hint.textContent = `Importo massimo: ${theme.Currency.formatMoney(
							variant.price,
							theme.settings.moneyFormat,
						)}`;
					}
				} else {
					this.input.removeAttribute("name");
					this.input.required = false;
					this.input.disabled = true;
					this.input.value = "";

					if (this.hint) {
						this.hint.textContent = "";
					}

					this.clearError();
				}
			}

			onSubmitHandler(event) {
				if (!this.isFreeFormVariant(this.currentVariant) || !this.input) {
					return;
				}

				const value = parseFloat(this.input.value);
				const max = this.currentVariant.price / 100;

				if (
					Number.isNaN(value) ||
					value < MINIMUM_FREE_FORM_DONATION_EUR ||
					value > max
				) {
					event.preventDefault();
					event.stopImmediatePropagation();
					this.showError(
						`Inserisci un importo tra 10,00 € e ${max.toFixed(2).replace(".", ",")} €.`,
					);
				} else {
					this.input.value = value.toFixed(2);
					this.clearError();
				}
			}

			showError(message) {
				if (!this.errorEl) return;
				this.errorEl.textContent = message;
				this.errorEl.hidden = false;
			}

			clearError() {
				if (!this.errorEl) return;
				this.errorEl.textContent = "";
				this.errorEl.hidden = true;
			}
		},
	);
}
